import { UserInfoResponse } from '@shared/types'

import { NameBase } from './NameBase'

export interface NameProps {
  user: Pick<UserInfoResponse, 'firstNames' | 'lastName'>
  isUppercase?: boolean
  /** defaults to string translated from key `common-cards-contact-info-name-label` */
  label?: string
}

export const NameFormSection = (props: NameProps) => {
  const { user, isUppercase, label } = props

  let firstNames: string
  let lastName: string

  if (isUppercase) {
    firstNames = user.firstNames.toUpperCase()
    lastName = user.lastName.toUpperCase()
  } else {
    firstNames = user.firstNames
    lastName = user.lastName
  }

  return <NameBase kind="labelled" firstNames={firstNames} lastName={lastName} label={label} />
}
